export default "__VITE_PUBLIC_ASSET__b4e8e4f4__"